import { LessonLink } from "@jelly/lesson";
import { findChapterForLinkByCourseLesson } from "../../../../services/Utils";
import course03 from "../../../course/course-03/course";
import lesson0316 from "../lesson-16/lesson";

const lessonLinks: LessonLink[] = [
  {
    id: "4c986395-b22d-42f0-95a7-8af6b44013f2",
    course: {
      id: course03.id,
      slug: course03.slug as string,
      name: course03.name,
      publicId: course03.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course03, lesson0316),
    lesson: lesson0316,
  },
];

export default lessonLinks;
